export enum ListIconHtmlVariant {
  Default = 'Default',
  Positive = 'Positive',
  Register = 'Register',
}
